export default __webpack_public_path__ + "static/media/vamos-buenos-aires.7a7d34d8.svg";